module.exports = __webpack_public_path__ + "static/media/course_01.95aee729.jpg";